export default __webpack_public_path__ + "static/media/info_icon.0edb3630.svg";